<template>
  <h2
    :class="[
      'main-subtitle',
      {
        'main-subtitle_v2': variant === 'v2',
      },
    ]"
  >
    <slot></slot>
  </h2>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      require: false,
      default: "v1",
    },
  },
};
</script>

<style scoped>
.main-subtitle {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--black-color);
  margin: 0;
}
.main-subtitle_v2 {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
</style>
